<template>
    <div>
        
        <TextBanner>
            <p> Block 4 ist <strong>1986</strong> gerade drei Jahre in Betrieb, als das <strong>Unglück</strong> passiert:</p>
        </TextBanner>
        

        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/01_1986_iPad_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/01_1986_iPad_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <!--<img class="o-fit o-fit--cover" src="../assets/img/fallback/TextBanner.jpg" alt="">-->
                <img class="o-fit o-fit--cover" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="">
            </picture>
        </Fallback>
    </div>
</template>

<script>
    export default {
        name: 'Jahr1986',
        babylonState: {
            moveCamera: [-6.4,1.2,26.5,8,2,-1.3],

            //neu damit die explosion schon im "jahr" geladen wird achtung: unten muss auch die animation resettet werden, wegen truemmer
            Geo_Explosion: false,

    
            Geo_Tschernobyl: {
                children: {
                    BG_Sphere: true,

                    Geo_Textur1_Reaktor_4_unversehrt: true,
                    Geo_Textur1_Reaktor_4_Damage: false,
                    Geo_Textur1_Reaktor_4_Damage_Aussen: false,
                    Geo_Textur1_Reaktor_4_Damage_Innen: false,
                    Geo_Neuer_Sarkophag_still: {
                        visible:false,
                        fade: true
                    },
                    Geo_Typo_1: true,
                    Geo_Typo_2: true,
                    Geo_Typo_3: true,
                    Geo_Typo_4: true,
                    Geo_Typo_Reaktor: true,
                    Geo_Typo_1986_Oben: true,
                    
                    Geo_KleinerTurm_Geruest1: false,
                    Geo_KleinerTurm_RoteStreifen1: false,
                    Geo_KleinerTurm_Schlot1: false,
                    Geo_KleinerTurm_Schattenplane: false,
                    
                    Geo_GrosserTurm_Gestaenge1: true,
                    Geo_GrosserTurm_Schlot1: true,
                    Geo_GrosserTurm_RoteStreifen1: true,
                    Geo_GrosserTurm_Schattenplane: true,
                }
            },

            fire: false,
        },
        babylonReady: function () {

            //this.$audioController.initTrack('speaker', require('./../assets/audio/Uebergang_01.mp3'), false, true);

            //Animation Explosion wird an Anfang gesetzt, um das objekt bereits im 1986.vue zu laden
            //this.$babylonController.goToAnimation("Explosion", 0.01),
            //this.$babylonController.startAnimation("Explosion_SkaleOut",false,1),  

            this.$babylonController.setAutoRotateBehaviour(false),
            this.$babylonController.setCameraRadiusLimit (8,150),
            this.$babylonController.zoomCamera(0.8)

            //Promo
            //this.$babylonController.zoomCamera(0.8)

            
        },
    }
</script>

<style lang="scss">

</style>